import React from 'react'

export interface DividerProps {
  id?: string
  className?: string
  orientation?: 'horizontal' | 'vertical'
  style?: React.CSSProperties
}

const Divider: React.FC<DividerProps> = ({ id = 'divider', className, orientation = 'horizontal', style }) => (
  <div
    id={id}
    className={className + ' divider--' + orientation}
    style={style}
    role="separator"
    aria-orientation={orientation}
  />
)

export default Divider
